import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.js';
import styled from '@emotion/styled';
import { Switch, FormControlLabel } from '@mui/material';
import isStyledPropsValid from '../utils/isStyledPropsValid.js';
const StyledSwitch = styled(Switch, {
  shouldForwardProp: isStyledPropsValid
})(_ref => {
  let {
    theme,
    checked,
    color
  } = _ref;
  return {
    // padding: 8,
    '&.MuiSwitch-root': {
      width: '34px',
      height: '18px',
      padding: '4px 5px',
      '& .MuiButtonBase-root': {
        padding: '1px',
        '&.Mui-checked': {
          transform: 'translateX(15px)',
          '& .MuiSwitch-thumb': {
            border: "2px solid ".concat(theme.customColors.white)
          },
          '&+.MuiSwitch-track': {
            opacity: 1,
            background: theme.customColors.purple[400]
          }
        }
      }
    },
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      opacity: 1,
      background: '#CCCCCC',
      '&:before, &:after': {
        content: '""',
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: 16,
        height: 16
      },
      '&:before': {
        backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"8\" width=\"8\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(theme.customColors.purple[500]), "\" d=\"M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z\"/></svg>')"),
        backgroundRepeat: 'no-repeat',
        left: 8,
        top: 13
      },
      '&:after': {
        backgroundImage: "url('data:image/svg+xml;utf8,<svg xmlns=\"http://www.w3.org/2000/svg\" height=\"8\" width=\"8\" viewBox=\"0 0 24 24\"><path fill=\"".concat(encodeURIComponent(theme.customColors.grey[500]), "\" d=\"M19,13H5V11H19V13Z\" /></svg>')"),
        backgroundRepeat: 'no-repeat',
        right: -1,
        top: 13
      }
    },
    '& .MuiSwitch-thumb': {
      width: 14,
      height: 14,
      margin: 1,
      border: "2px solid ".concat(theme.palette[color].main),
      boxShadow: "0px 0px 4px 0px #27272759"
    }
  };
});
const StyledFormControlLabel = styled(FormControlLabel, {
  shouldForwardProp: isStyledPropsValid
})(_ref2 => {
  let {
    theme,
    sx
  } = _ref2;
  return _objectSpread2({
    marginLeft: 0,
    marginRight: 0
  }, sx);
});
const IosSwitch = styled(Switch)(_ref3 => {
  let {
    theme,
    sx,
    backgroundColor,
    disabledOpacity
  } = _ref3;
  return {
    width: 40,
    height: 20,
    padding: 0,
    display: 'flex',
    '&:active': {
      '& .MuiSwitch-thumb': {
        width: 15
      },
      '& .MuiSwitch-switchBase.Mui-checked': {
        transform: 'translateX(20px)'
      }
    },
    '& .MuiSwitch-switchBase': {
      padding: 2,
      '&.Mui-checked': {
        transform: 'translateX(20px)',
        color: '#fff',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: backgroundColor.checkedColor
          // ...theme.applyStyles('dark', {
          // 	backgroundColor: '#177ddc',
          // }),
        }
      },
      '&.Mui-disabled': {
        '& + .MuiSwitch-track': {
          opacity: disabledOpacity
        }
      }
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 16,
      height: 16,
      borderRadius: 8,
      transition: theme.transitions.create(['width'], {
        duration: 200
      }),
      backgroundColor: 'white'
    },
    '& .MuiSwitch-track': {
      borderRadius: '20px',
      opacity: 1,
      backgroundColor: backgroundColor.uncheckedColor,
      boxSizing: 'border-box'
      // ...theme.applyStyles('dark', {
      // 	backgroundColor: 'rgba(255,255,255,.35)',
      // }),
    }
  };
});
export { IosSwitch, StyledFormControlLabel, StyledSwitch };